import React from 'react';
import Link from 'next/link';
import Date from './date';
import Image from 'next/image';

import { H6, Muted } from './text';
import { IFeaturedImage } from '../models/featured-image';

interface IProps {
	title: string;
	coverImage: IFeaturedImage;
	baseSlug: string;
	slug: string;
	date: string;
}

export default function FeaturedVideoPost({
	title,
	coverImage,
	baseSlug,
	slug,
	date,
}: IProps) {
	return (
		<section className="mb-0">
			<div className="flex flex-col bg-transparent mb-4 h-auto overflow-hidden rounded-sm">
				{coverImage && (
					<Link href={`/${baseSlug}/${slug}`}>
						<Image
							width={1280}
							height={720}
							alt={title}
							src={coverImage?.node.sourceUrl}
							className="aspect-video object-cover rounded-t-sm hover:opacity-75 transition-opacity"
						/>
					</Link>
				)}
			</div>
			<div className="pl-0 pr-4 pt-2 pb-0">
				<H6 className="mb-2">
					<Link
						href={`/${baseSlug}/${slug}`}
						className="text-white hover:underline"
						dangerouslySetInnerHTML={{ __html: title }}
					></Link>
				</H6>
				<Muted>
					<Date dateString={date} />
				</Muted>
			</div>
		</section>
	);
}
